import axios from 'axios';

interface LoginCredentials {
  username: string;
  password: string;
}

interface AuthResponse {
  AccessToken: string;
  IdToken: string;
  RefreshToken: string;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    try {
      const response = await axios.post<AuthResponse>(
        `${import.meta.env.VITE_API_BASE_URL}/auth/login`,
        {
          username: credentials.username,
          password: credentials.password,
        }
      );

      const authResult = response.data;
      
      // Store tokens in localStorage
      localStorage.setItem('accessToken', authResult.AccessToken);
      localStorage.setItem('idToken', authResult.IdToken);
      localStorage.setItem('refreshToken', authResult.RefreshToken);

      return authResult;
    } catch (error: any) {
      if (error.response?.status === 401) {
        throw new Error('ユーザー名またはパスワードが正しくありません');
      } else if (error.code === 'NETWORK_ERROR' || !error.response) {
        throw new Error('接続に失敗しました。再度お試しください');
      } else {
        throw new Error('ログインに失敗しました');
      }
    }
  }

  logout(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('refreshToken');
  }

  getIdToken(): string | null {
    return localStorage.getItem('idToken');
  }

  isAuthenticated(): boolean {
    const token = this.getIdToken();
    if (!token) return false;

    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const padding = base64.length % 4;
      const paddedBase64 = padding ? base64 + '='.repeat(4 - padding) : base64;
      
      const rawData = atob(paddedBase64);
      const bytes = new Uint8Array(rawData.length);
      for (let i = 0; i < rawData.length; i++) {
        bytes[i] = rawData.charCodeAt(i);
      }
      const jsonPayload = new TextDecoder().decode(bytes);
      const payload = JSON.parse(jsonPayload);
      
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp > currentTime;
    } catch {
      return false;
    }
  }
}

export const authService = new AuthService();
